<div #textboxDisplay class="textbox-display" [innerHTML]="text"></div>

{{getStyles(textboxDisplay)}}